<template>
    <v-container fluid class="pa-0">
        <!-- loading status -->
        <v-row class="ma-0 pa-0">
            <v-progress-linear
                v-if="$apollo.queries.greenhouses.loading"
                color="primary"
                indeterminate
                rounded
                class="ma-0 pa-0"
            ></v-progress-linear>
        </v-row>
        <v-row class="align-start mb-0 pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[{text: 'Home', disable: false, href: '/#/'}, {text: 'Greenhouses', disabled: true}]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer></v-spacer>
            <v-btn
                v-if="hasPermission('add_greenhouse')"
                color="primary"
                dark
                outlined
                rounded
                small
                class="mr-5 mt-3"
                :loading="$apollo.queries.greenhouses.loading"
                @click="greenhouseEditDialog=true"
            >New Greenhouse</v-btn>
        </v-row>

        <GreenhouseEditDialog
            :dialog.sync="greenhouseEditDialog"
            :object.sync="editedGreenhouse"
            v-on:item-created="goToGreenhouseDetail"
        ></GreenhouseEditDialog>

        <v-row class="mx-3">
            <!-- <v-col cols="12" v-if="!isLoadingGreenhouses && greenhouses.length==0">
                <v-row class="justify-center">
                    <v-btn
                        color="primary"
                        outlined
                        rounded
                        @click="greenhouseEditDialog=true"
                    >Add Greenhouse</v-btn>
                </v-row>
            </v-col>-->

            <v-col
                cols="12"
                md="6"
                class="pa-2"
                v-for="greenhouse in greenhouses.edges"
                :key="greenhouse.node.id"
                :set="scale=getScale(greenhouse.node.width, greenhouse.node.height)"
            >
                <v-card class="mx-auto mb-2 pb-0" height="100%">
                    <v-card-title>
                        <span>
                            {{ greenhouse.node.name }}
                            <v-btn text icon @click="goToGreenhouseDetail(greenhouse.node)">
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="hasPermission('change_greenhouse')"
                            fab
                            text
                            @click="onEditGreenhouse(greenhouse.node)"
                        >
                            <v-icon color="grey darken-1">edit</v-icon>
                        </v-btn>
                        <!-- <v-btn fab text @click="goToGreenhouseDetail(greenhouse.node)">
                            <v-icon>arrow_forward</v-icon>
                        </v-btn>-->
                    </v-card-title>
                    <!-- <v-card-text># Departments: {{ countGreenhouseDepartments(greenhouse) }}</v-card-text> -->
                    <v-card
                        class="my-5 pa-2 mx-auto"
                        outlined
                        :width="thumbnailWidth + 16"
                        :height="thumbnailWidth + 16"
                        @click="goToGreenhouseDetail(greenhouse.node)"
                    >
                        <div
                            :style="{
                                        position: 'relative',
                                        width: (greenhouse.node.width) + 'px', 
                                        height: (greenhouse.node.height ) + 'px', 
                                        margin: 'auto',
                                        left: (thumbnailWidth - greenhouse.node.width * scale) / 2 + 'px',
                                        top: (thumbnailWidth - greenhouse.node.height * scale) / 2 + 'px',
                                        transform: 'scale(' + scale + ')',
                                        transformOrigin: 'left top'}"
                        >
                            <VueDraggableResizable
                                v-for="department in greenhouse.node.greenhouseDepartmentSet.edges"
                                :key="department.node.id"
                                :x="department.node.layoutX"
                                :y="department.node.layoutY"
                                :w="department.node.width"
                                :h="department.node.height"
                                :z="100"
                                :min-width="10"
                                :min-height="10"
                                :draggable="draggable"
                                :resizable="resizable"
                                @dragging="onDrag"
                                @resizing="onResize"
                                :parent="true"
                                :scale="scale"
                                :grid="[10,10]"
                                style="backgroundColor: white"
                                class-name-active="elevation-10"
                            >
                                <v-card
                                    class="d-flex align-center justify-space-around"
                                    height="100%"
                                    width="100%"
                                    tile
                                    @click="goToGreenhouseDepartment(department.node)"
                                    :style="{ backgroundColor: department.node.isPlaceholder ? 'grey' : 'rgba(0, 255, 0, ' + department.node.totalUsedRate + ')' }"
                                >
                                    <span
                                        v-if="!department.node.isPlaceholder"
                                        :class="['text-center', department.node.isPlaceholder ? 'white--text  display-2' : ' display-3 font-weight-regular' ]"
                                    >{{ department.node.name }}</span>
                                </v-card>
                            </VueDraggableResizable>
                        </div>
                    </v-card>
                </v-card>
            </v-col>
        </v-row>

        <!-- Departments -->
        <!-- <v-row>
            <v-data-table
                :headers="headers"
                :loading="$apollo.queries.greenhouses.loading"
                :items="departments"
                :search="searchDepartment"
                sortBy="name"
                loading-text="Loading... Please wait"
            ></v-data-table>
        </v-row>-->
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import GreenhouseEditDialog from "@/components/greenhouse/GreenhouseEditDialog.vue";

export default {
    name: "greenhouse-list-page",
    components: {
        VueDraggableResizable,
        GreenhouseEditDialog
    },

    apollo: {
        greenhouses: {
            query: gql`
                query greenhouses {
                    greenhouses {
                        edges {
                            node {
                                id
                                name
                                width
                                height
                                greenhouseDepartmentSet {
                                    edges {
                                        node {
                                            id
                                            name
                                            totalSpaceM2
                                            totalUsedSpaceM2
                                            totalUsedRate
                                            isPlaceholder
                                            layoutX
                                            layoutY
                                            width
                                            height
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {},
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.greenhouses,
            pollInterval: 60000 // ms
            // pollInterval: 300 // ms
        }
    },

    data: function() {
        return {
            isLoadingGreenhouses: false,
            greenhouseEditDialog: false,

            editedGreenhouse: null,

            greenhouses: {},

            searchDepartment: "",

            draggable: false,
            resizable: false,
            showGrid: false,
            // browserSize: {
            //     width: 0,
            //     height: 0
            // },
            departmentSize: {
                widthMeters: 100,
                heightMeters: 100
            },
            defaultSectionSize: {
                widthMeters: 40,
                heightMeters: 4
            },
            editedItem: {
                x: 0,
                y: 0,
                w: 0,
                h: 0
            },

            headers: [
                {
                    text: "Greenhouse",
                    value: "greenhouse.name",
                    sortable: true
                },
                {
                    text: "Department",
                    value: "name",
                    sortable: true
                }
            ]
        };
    },
    computed: {
        // greenhouses() {
        //     return this.$store.state.greenhouses.greenhouses;
        // },
        thumbnailWidth() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return 300;
                case "sm":
                    return 500;
                case "md":
                    return 400;
                case "lg":
                    return 400;
                case "xl":
                    return 400;
                default:
                    return 400;
            }
        }

        // departments() {
        //     var _departments = [];

        //     if (this.greenhouses.edges) {
        //         this.greenhouses.edges.forEach(greenhouse => {
        //             _departments.push(
        //                 ...greenhouse.node.greenhouseDepartmentSet.edges.map(
        //                     item => {
        //                         return {
        //                             ...item.node,
        //                             greenhouse: greenhouse.node
        //                         };
        //                     }
        //                 )
        //             );
        //         });
        //     }

        //     console.log(_departments);

        //     return _departments;
        // }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {},
    methods: {
        onEditGreenhouse(greenhouse) {
            this.editedGreenhouse = greenhouse;
            this.greenhouseEditDialog = true;
        },

        goToGreenhouseDetail(greenhouse) {
            this.$router.push({
                name: "greenhouse-detail",
                params: { id: greenhouse.id }
            });
        },

        goToGreenhouseDepartment(department) {
            if (!department.isPlaceholder) {
                this.$router.push({
                    name: "greenhouse-department",
                    params: { id: department.id }
                });
            }
        },

        countGreenhouseDepartments(greenhouse) {
            return greenhouse.node.greenhouseDepartmentSet.edges.filter(
                item => !item.node.isPlaceholder
            ).length;
        },

        getScale(width, height) {
            const scaleX = this.thumbnailWidth / width;
            const scaleY = this.thumbnailWidth / height;

            return Math.min(scaleX, scaleY);
        },

        zoomOut() {
            this.scale = this.scale - 0.1 || 0;
        },
        zoomIn() {
            this.scale = this.scale + 0.1 || 1;
        },
        onResize(x, y, width, height) {
            this.editedItem.x = x;
            this.editedItem.y = y;
            this.editedItem.w = width;
            this.editedItem.h = height;
        },
        onDrag(x, y) {
            this.editedItem.x = x;
            this.editedItem.y = y;
        }
    }
};
</script>


<style scoped>
.crossed {
    background: linear-gradient(
            to top left,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - 0.8px),
            rgba(0, 0, 0, 1) 50%,
            rgba(0, 0, 0, 0) calc(50% + 0.8px),
            rgba(0, 0, 0, 0) 100%
        ),
        linear-gradient(
            to top right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - 0.8px),
            rgba(0, 0, 0, 1) 50%,
            rgba(0, 0, 0, 0) calc(50% + 0.8px),
            rgba(0, 0, 0, 0) 100%
        );
}
</style>